import React from 'react'
import { Box } from '@mui/material'

const classes = {
    spinner: (size = 16, thickness = 4) => ({
        border: `${thickness}px solid #f3f3f3`,
        borderTop: `${thickness}px solid #3498db`,
        borderRadius: '50%',
        width: size,
        height: size,
        animation: 'spin 2s linear infinite',
    }),
}

const Spinner = ({ size, thickness }) => {
    return (
        <>
            <Box sx={classes.spinner(size, thickness)} />
            <style>{`
                @keyframes spin {
                     0% { transform: rotate(0deg); }
                     100% { transform: rotate(360deg); }
                }
            `}</style>
        </>
    )
}

export default Spinner
